export default __webpack_public_path__ + "static/media/AvenirNext-Regular.e6a39c76.otf";